import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import ZonePicker from '../components/ZonePicker';
import { parseLocation, uzbekistonIchida, almashganKoordinata } from '../parseLocation';
import { tr } from '../til';

const inputStyle = {
  padding: '10px 12px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '14px'
};

const smallBtn = {
  padding: '6px 12px',
  background: '#eef1f7',
  color: '#1a1a2e',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '12px',
  cursor: 'pointer'
};

const emptyForm = () => ({
  name: '', latitude: '', longitude: '', radius_meters: '200', is_active: true
});

// Radius uchun tayyor o'lchamlar — admin metrni o'zi o'ylab topmasin.
const OLCHAMLAR = [
  { label: tr("Bino"), metr: 200 },
  { label: tr("Mahalla"), metr: 1000 },
  { label: tr("Tuman"), metr: 5000 },
  { label: tr("Shahar"), metr: 15000 }
];

function ZoneForm({ form, setForm }) {
  const set = (field, value) => setForm({ ...form, [field]: value });

  const [havola, setHavola] = useState('');
  const [havolaXabar, setHavolaXabar] = useState(null);
  // Koordinata holati: o'rni almashganmi yoki umuman boshqa mamlakatdami.
  const lat = Number(form.latitude);
  const lng = Number(form.longitude);
  const toldirilgan = form.latitude !== '' && form.longitude !== ''
    && Number.isFinite(lat) && Number.isFinite(lng);
  const almashgan = toldirilgan && almashganKoordinata(lat, lng);
  const tashqarida = toldirilgan && !almashgan && !uzbekistonIchida(lat, lng);

  const almashtir = () => setForm({ ...form, latitude: form.longitude, longitude: form.latitude });

  // Xaritada bosilganda ikkala koordinata birdan yangilanadi.
  const pick = (lat, lng) => setForm({
    ...form,
    latitude: lat.toFixed(6),
    longitude: lng.toFixed(6)
  });

  // Telegramdan kelgan lokatsiya havolasi qo'yilganda koordinata o'zi ajraladi.
  const havolaniOqi = (matn) => {
    setHavola(matn);

    if (!matn.trim()) { setHavolaXabar(null); return; }

    const nuqta = parseLocation(matn);

    if (!nuqta) {
      setHavolaXabar({ xato: true, matn: tr("Bu matndan koordinata topilmadi. Havolani to'liq nusxalaganingizni tekshiring.") });
      return;
    }

    if (nuqta.qisqaHavola) {
      setHavolaXabar({
        xato: true,
        matn: tr("Bu qisqartirilgan havola — ichida koordinata yo'q. Uni brauzerda oching, ochilgan sahifaning to'liq manzilini nusxalab shu yerga qo'ying.")
      });
      return;
    }

    setForm({
      ...form,
      latitude: nuqta.latitude.toFixed(6),
      longitude: nuqta.longitude.toFixed(6)
    });

    setHavolaXabar(
      nuqta.uzbekistondanTashqarida
        ? { xato: true, matn: tr("Koordinata olindi, lekin bu nuqta O'zbekistondan tashqarida. Kenglik va uzunlik o'rni almashib ketmaganini xaritadan tekshiring.") }
        : { xato: false, matn: tr("Koordinata olindi — xaritada belgilandi.") }
    );
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
      <input
        type="text"
        placeholder={tr("Zona nomi * (masalan: Bosh boshqarma)")}
        value={form.name}
        onChange={e => set('name', e.target.value)}
        style={{ ...inputStyle, gridColumn: '1 / -1' }}
      />

      <div style={{ gridColumn: '1 / -1' }}>
        <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '6px' }}>
          {tr("Lokatsiya havolasini qo'ying")}
        </label>
        <input
          type="text"
          placeholder={tr("Telegramdagi lokatsiyani oching → havolani nusxalang → shu yerga qo'ying")}
          value={havola}
          onChange={e => havolaniOqi(e.target.value)}
          style={{ ...inputStyle, width: '100%', boxSizing: 'border-box' }}
        />
        {havolaXabar ? (
          <p style={{
            margin: '6px 0 0',
            fontSize: '12px',
            color: havolaXabar.xato ? '#c93636' : '#2d8a2d'
          }}>
            {havolaXabar.matn}
          </p>
        ) : (
          <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#999' }}>
            {tr("Google Maps, Yandex Xarita havolasi yoki oddiy «41.311081, 69.240562» ko'rinishidagi koordinata — barchasi bo'ladi.")}
          </p>
        )}
      </div>

      <div style={{ gridColumn: '1 / -1' }}>
        <ZonePicker
          latitude={form.latitude}
          longitude={form.longitude}
          radius={form.radius_meters}
          onPick={pick}
        />
      </div>

      <input
        type="text"
        placeholder={tr("Kenglik / Latitude *")}
        value={form.latitude}
        onChange={e => set('latitude', e.target.value)}
        style={inputStyle}
      />
      <input
        type="text"
        placeholder={tr("Uzunlik / Longitude *")}
        value={form.longitude}
        onChange={e => set('longitude', e.target.value)}
        style={inputStyle}
      />
      {almashgan && (
        <div style={{
          gridColumn: '1 / -1', background: '#fff6e5', border: '1px solid #f0c987',
          borderRadius: '8px', padding: '10px 12px', fontSize: '13px', color: '#8a5a00',
          display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap'
        }}>
          <span>
            {tr("Kenglik va uzunlik o'rni almashib ketganga o'xshaydi: bu nuqta O'zbekistondan tashqarida, almashtirilsa — ichida.")}
          </span>
          <button type="button" onClick={almashtir}
            style={{ ...smallBtn, background: '#8a5a00', color: '#fff', border: 'none' }}>
            {tr("Almashtirib qo'yish")}
          </button>
        </div>
      )}

      {tashqarida && (
        <div style={{
          gridColumn: '1 / -1', background: '#ffeaea', border: '1px solid #f0a0a0',
          borderRadius: '8px', padding: '10px 12px', fontSize: '13px', color: '#c93636'
        }}>
          {tr("Bu nuqta O'zbekistondan tashqarida. Xaritadan tekshiring — koordinata xato bo'lsa, davomat hech qachon \"ish joyida\" deb belgilanmaydi.")}
        </div>
      )}

      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
        <input
          type="number"
          min="1"
          placeholder={tr("Radius (metr) *")}
          value={form.radius_meters}
          onChange={e => set('radius_meters', e.target.value)}
          style={{ ...inputStyle, width: '120px' }}
        />
        {OLCHAMLAR.map(o => (
          <button
            key={o.metr}
            type="button"
            onClick={() => set('radius_meters', String(o.metr))}
            title={tr("{metr} metr", { metr: o.metr })}
            style={{
              ...smallBtn,
              background: Number(form.radius_meters) === o.metr ? '#1a1a2e' : '#eef1f7',
              color: Number(form.radius_meters) === o.metr ? '#fff' : '#1a1a2e'
            }}
          >
            {o.label}
          </button>
        ))}
      </div>
      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#555' }}>
        <input
          type="checkbox"
          checked={form.is_active}
          onChange={e => set('is_active', e.target.checked)}
        />
        {tr("Faol (o'chirilsa hisobga olinmaydi)")}
      </label>
    </div>
  );
}

function WorkZones() {
  const [zones, setZones] = useState([]);
  const [form, setForm] = useState(emptyForm());
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);

  const [editing, setEditing] = useState(null);
  const [editError, setEditError] = useState('');

  const token = localStorage.getItem('token');

  const load = useCallback(() => {
    axios.get(`${API}/attendance/zones`, { headers: { authorization: token } })
      .then(res => setZones(res.data));
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  const validate = (f) => {
    if (!f.name.trim()) return tr("Zona nomini kiriting");
    if (!f.latitude || isNaN(Number(f.latitude))) return tr("Kenglikni to'g'ri kiriting");
    if (!f.longitude || isNaN(Number(f.longitude))) return tr("Uzunlikni to'g'ri kiriting");
    if (!f.radius_meters || Number(f.radius_meters) <= 0) return tr("Radiusni to'g'ri kiriting");
    return null;
  };

  // Nuqta mamlakatdan tashqarida bo'lsa — jimgina saqlamaymiz. Bunday
  // zona hech qachon ishlamaydi: xodim binoda tursa ham "tashqarida"
  // chiqaveradi va buni oylar o'tib payqashadi.
  const tashqaridaTasdiq = (f) => {
    const lat = Number(f.latitude), lng = Number(f.longitude);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return true;
    if (uzbekistonIchida(lat, lng)) return true;
    const xabar = almashganKoordinata(lat, lng)
      ? tr("Kenglik va uzunlik o'rni almashib ketganga o'xshaydi — bu nuqta O'zbekistondan tashqarida.\n\nBaribir saqlansinmi?")
      : tr("Bu nuqta O'zbekistondan tashqarida.\n\nBaribir saqlansinmi?");
    return window.confirm(xabar);
  };

  const create = async () => {
    setError('');
    setSuccess('');

    const invalid = validate(form);
    if (invalid) { setError(invalid); return; }
    if (!tashqaridaTasdiq(form)) return;

    setSaving(true);
    try {
      await axios.post(`${API}/attendance/zones`, form, { headers: { authorization: token } });
      setSuccess(tr("\"{name}\" qo'shildi.", { name: form.name }));
      setForm(emptyForm());
      load();
    } catch (err) {
      setError(err.response?.data?.error || tr("Zona qo'shilmadi."));
    } finally {
      setSaving(false);
    }
  };

  const saveEdit = async () => {
    setEditError('');
    const invalid = validate(editing);
    if (invalid) { setEditError(invalid); return; }
    if (!tashqaridaTasdiq(editing)) return;

    try {
      await axios.put(`${API}/attendance/zones/${editing.id}`, editing, {
        headers: { authorization: token }
      });
      setSuccess(tr("Zona yangilandi."));
      setEditing(null);
      load();
    } catch (err) {
      setEditError(err.response?.data?.error || tr("Saqlanmadi."));
    }
  };

  const remove = async (zone) => {
    setError('');
    setSuccess('');
    if (!window.confirm(tr("\"{name}\" zonasi o'chirilsinmi?", { name: zone.name }))) return;

    try {
      await axios.delete(`${API}/attendance/zones/${zone.id}`, { headers: { authorization: token } });
      setSuccess(tr("Zona o'chirildi."));
      load();
    } catch (err) {
      setError(err.response?.data?.error || tr("O'chirib bo'lmadi."));
    }
  };

  return (
    <div>
      <h2 style={{ marginBottom: '8px', fontSize: '22px' }}>{tr("Ish zonalari")}</h2>
      <p style={{ marginTop: 0, marginBottom: '20px', color: '#888', fontSize: '13px' }}>
        {tr("Xodim belgilanganda shu doiralardan biri ichida bo'lsa — \"ish joyida\", aks holda \"zona tashqarida\" hisoblanadi.")}
      </p>

      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)', marginBottom: '24px' }}>
        <h3 style={{ marginBottom: '16px', fontSize: '16px' }}>{tr("Yangi zona")}</h3>

        <ZoneForm form={form} setForm={setForm} />

        <div style={{ background: '#f6f8fb', borderRadius: '8px', padding: '12px', margin: '14px 0', fontSize: '12px', color: '#666', lineHeight: '1.6' }}>
          <strong>{tr("Radius haqida:")}</strong> {tr("bino uchun")} <strong>{tr("150–250 metr")}</strong> {tr("tavsiya etiladi. Juda kichik qilsangiz (masalan 50 m), telefon GPS'ining tabiiy xatoligi (10–50 m) sababli xodim binoda turib ham \"tashqarida\" chiqishi mumkin.")}
          <br />
          {tr("Butun tumanni qamrash uchun 5 km yoki undan katta radius ham qo'ysa bo'ladi, lekin unda nazorat susayadi: xodim o'sha tuman ichidagi uyida turib ham \"ish joyida\" deb belgilanaveradi.")}
        </div>

        {error && (
          <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '12px' }}>
            {error}
          </div>
        )}
        {success && (
          <div style={{ background: '#e9f9ed', color: '#2d8a2d', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '12px' }}>
            {success}
          </div>
        )}

        <button
          onClick={create}
          disabled={saving}
          style={{
            padding: '10px 24px',
            background: saving ? '#888' : '#1a1a2e',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            width: '100%',
            cursor: saving ? 'default' : 'pointer'
          }}
        >
          {saving ? tr("Qo'shilmoqda...") : tr("Qo'shish")}
        </button>
      </div>

      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Nomi")}</th>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Koordinata")}</th>
              <th style={{ textAlign: 'center', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Radius")}</th>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Holat")}</th>
              <th style={{ textAlign: 'right', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Amallar")}</th>
            </tr>
          </thead>
          <tbody>
            {zones.map(z => (
              <tr key={z.id} style={{ borderBottom: '1px solid #f9f9f9', opacity: z.is_active ? 1 : 0.5 }}>
                <td style={{ padding: '10px 8px', fontWeight: '500' }}>{z.name}</td>
                <td style={{ padding: '10px 8px', color: '#888', fontSize: '13px' }}>
                  {Number(z.latitude).toFixed(6)}, {Number(z.longitude).toFixed(6)}
                  {!uzbekistonIchida(z.latitude, z.longitude) && (
                    <span style={{
                      marginLeft: '8px', background: '#ffeaea', color: '#c93636',
                      padding: '2px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: 600
                    }}>
                      {almashganKoordinata(z.latitude, z.longitude)
                        ? tr("koordinata almashgan")
                        : tr("O'zbekistondan tashqarida")}
                    </span>
                  )}
                  <a
                    href={`https://www.google.com/maps?q=${z.latitude},${z.longitude}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{ marginLeft: '8px', color: '#4f8ef7', fontSize: '12px' }}
                  >
                    {tr("xaritada ↗")}
                  </a>
                </td>
                <td style={{ padding: '10px 8px', textAlign: 'center', color: '#555' }}>
                  {z.radius_meters} m
                </td>
                <td style={{ padding: '10px 8px' }}>
                  <span style={{
                    background: z.is_active ? '#e9f9ed' : '#f0f0f0',
                    color: z.is_active ? '#2d8a2d' : '#999',
                    padding: '3px 10px',
                    borderRadius: '20px',
                    fontSize: '12px'
                  }}>
                    {z.is_active ? tr("Faol") : tr("O'chiq")}
                  </span>
                </td>
                <td style={{ padding: '10px 8px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <button
                    onClick={() => {
                      setEditError('');
                      setEditing({ ...z, latitude: String(z.latitude), longitude: String(z.longitude), radius_meters: String(z.radius_meters) });
                    }}
                    style={{ ...smallBtn, marginRight: '6px' }}
                  >
                    {tr("Tahrirlash")}
                  </button>
                  <button onClick={() => remove(z)} style={{ ...smallBtn, color: '#c93636' }}>
                    {tr("O'chirish")}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {zones.length === 0 && (
          <p style={{ color: '#999', fontSize: '14px', textAlign: 'center', margin: '20px 0 0' }}>
            {tr("Hali zona qo'shilmagan. Zona bo'lmasa, barcha belgilanishlar \"zona tashqarida\" ko'rinadi.")}
          </p>
        )}
      </div>

      {editing && (
        <div
          onClick={() => setEditing(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', zIndex: 100
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: '12px', padding: '24px',
              width: '100%', maxWidth: '680px', maxHeight: '90vh', overflowY: 'auto'
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '18px' }}>{tr("Zonani tahrirlash")}</h3>

            <ZoneForm form={editing} setForm={setEditing} />

            {editError && (
              <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginTop: '12px' }}>
                {editError}
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button onClick={() => setEditing(null)} style={{ ...smallBtn, padding: '10px 20px', fontSize: '14px' }}>
                {tr("Bekor qilish")}
              </button>
              <button
                onClick={saveEdit}
                style={{
                  padding: '10px 24px', background: '#1a1a2e', color: '#fff',
                  border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer'
                }}
              >
                {tr("Saqlash")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default WorkZones;
